//#region src/core/combine.ts
/**
* Combines multiple slices into a single slice.
*
* @param slices - The slices to combine.
* @returns A new slice that represents the combination of the input slices.
*/
function combine(...slices) {
	const derivedDefinitions = slices.map((slice) => slice.derived ?? {});
	warnDuplicates("derived", derivedDefinitions);
	return {
		state: (ctx) => {
			const states = slices.map((slice) => slice.state(ctx));
			warnDuplicates("state", states);
			warnOverlaps(states, derivedDefinitions);
			return Object.assign({}, ...states);
		},
		preserve: Array.from(new Set(slices.flatMap((slice) => slice.preserve ?? []))),
		derived: Object.assign({}, ...derivedDefinitions),
		attach: (ctx) => {
			for (const slice of slices) try {
				slice.attach?.(ctx);
			} catch (err) {
				ctx.reportError(err);
			}
		}
	};
}
function warnDuplicates(namespace, objects) {
	const seen = /* @__PURE__ */ new Set();
	for (const object of objects) for (const key of Reflect.ownKeys(object)) {
		if (seen.has(key)) console.warn(`[vjs-store] combine(): duplicate ${namespace} key "${String(key)}" — later slice overwrites earlier one`);
		seen.add(key);
	}
}
function warnOverlaps(states, derivedDefinitions) {
	const stateKeys = new Set(states.flatMap((state) => Reflect.ownKeys(state)));
	for (const key of new Set(derivedDefinitions.flatMap((derived) => Reflect.ownKeys(derived)))) if (stateKeys.has(key)) console.warn(`[vjs-store] combine(): state and derived key "${String(key)}" overlap — derived state overwrites source state`);
}
//#endregion
export { combine };

//# sourceMappingURL=combine.js.map